/* START AANPASSING PRODUCTPAGINA MOBIEL */
/* 2-9-2026 — Optivaize. PUNT 2: mobiele sectievolgorde op de productpagina.
   Onder 769px wordt de sectie 'details' (Beschrijving + Specificaties) verplaatst naar direct na het koopblok
   (vóór de kortingskop 'Wil je korting…', anders vóór de eerste accessoire-tip). Boven 769px staat de sectie
   op zijn oorspronkelijke plek. Het bestaande DOM-element wordt verplaatst (event-listeners blijven intact);
   Liquid/HTML en de desktopvolgorde blijven onaangeroerd. Zonder JS blijft de huidige volgorde staan.
   Terugdraaien: de script-regel in layout/theme.liquid verwijderen. */
(function () {
  'use strict';
  var MQ = window.matchMedia('(max-width: 768.98px)');
  var placeholder = null;

  function detailsSection() {
    return document.querySelector('[id^="shopify-section-"][id$="__details"]');
  }
  function anchorBlock() {
    var col = document.querySelector('.product-info__sticky');
    if (!col) return null;
    // Keep the approved purchase/form/USP sequence together on mobile.
    var discount = col.querySelector('#formful__form_form_BWp8QeVxOa');
    if (discount) {
      var formBlock = discount.closest('.product-info__block');
      var usps = col.querySelector('.ft-usps');
      var uspBlock = usps && usps.closest('.product-info__block');
      var after = uspBlock || formBlock;
      var next = after && after.nextElementSibling;
      if (next === detailsSection()) next = next.nextElementSibling;
      return next;
    }
    var head = col.querySelector('.ft-korting-head');
    if (head) return head.closest('.product-info__block');
    var tip = col.querySelector('.ft-wp-tip, .ft-af-tip');
    if (tip) return tip.closest('.product-info__block');
    return null;
  }
  function apply() {
    var details = detailsSection();
    if (!details) return;
    // Tenerife's description and unchanged backorder notice stay below the checkmarks at every width.
    if (MQ.matches || document.querySelector('[data-ft-tenerife-backorder]')) {
      var anchor = anchorBlock();
      if (!anchor || anchor.previousElementSibling === details) return;
      if (!placeholder || !placeholder.parentNode) {
        placeholder = document.createComment('ft-details-placeholder');
        details.parentNode.insertBefore(placeholder, details);
      }
      anchor.parentNode.insertBefore(details, anchor);
      details.classList.add('ft-details--moved');
    } else if (placeholder && placeholder.parentNode) {
      placeholder.parentNode.insertBefore(details, placeholder);
      placeholder.parentNode.removeChild(placeholder);
      placeholder = null;
      details.classList.remove('ft-details--moved');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  if (MQ.addEventListener) { MQ.addEventListener('change', apply); } else if (MQ.addListener) { MQ.addListener(apply); }
  document.addEventListener('shopify:section:load', function () { placeholder = null; apply(); });
})();
/* EINDE AANPASSING PRODUCTPAGINA MOBIEL */
